export default __webpack_public_path__ + "static/media/Image3.2e936591.png";